import { FormattedTextTileDelta, TextTileDeltaType, TextTileDeltaUnit } from '@augloop/types-text';
import { getMinimalDifferenceBounds } from './utils';
import equal from 'fast-deep-equal';
const WORD_BOUNDARY_REGEXP = /[ \u00a0\u2000-\u200a\u202f\u205f\u3000\t]/g;
const SENTENCE_BOUNDARY_REGEXP = /[.!?]/g;
export function textTileDeltaBuilderHandler(oldTile, newTile) {
    const retVal = [];
    const contentDelta = createContentDelta(oldTile, newTile);
    if (contentDelta) {
        retVal.push(contentDelta);
    }
    return retVal;
}
export function formatedTextTileDeltaBuilderHandler(oldTile, newTile) {
    const retVal = [];
    const contentDelta = createContentDelta(oldTile, newTile);
    if (contentDelta) {
        retVal.push(contentDelta);
    }
    const cursorUpdateDelta = createCursorUpdateDelta(oldTile, newTile, contentDelta);
    if (cursorUpdateDelta) {
        retVal.push(cursorUpdateDelta);
    }
    const formattingUpdateDelta = createFormattingUpdateDelta(oldTile, newTile, contentDelta);
    if (formattingUpdateDelta) {
        retVal.push(formattingUpdateDelta);
    }
    const otherNonContentDelta = createOtherNonContentUpdateDelta(oldTile, newTile);
    if (otherNonContentDelta) {
        retVal.push(otherNonContentDelta);
    }
    return retVal;
}
function createContentDelta(oldTile, newTile) {
    const oldText = oldTile.content;
    const newText = newTile.content;
    const minDiffBounds = getMinimalDifferenceBounds(oldText, newText);
    const position = minDiffBounds.firstDiffLeft;
    const oldTextDiffEnd = oldText.length - minDiffBounds.firstDiffRight;
    const newTextDiffEnd = newText.length - minDiffBounds.firstDiffRight;
    // Determine Delta Type
    // - An add means that min diff bounds applied to the old text return no invalidation range
    //   (same chp)
    //   oldText: |xxxxxxxxxxxxxx|
    //   minDiffB:    (7)^(8)
    //   newText: |xxxxxxxyyyxxxxxxxx|
    //   minDiffB:    (7)^   ^(8)
    //
    // A delete means that min diff bounds applied to the new text return no invalidation range
    //   (same chp)
    //   oldText: |xxxxxxxyyyxxxxxxxx|
    //   minDiffB:    (7)^   ^(8)
    //   newText: |xxxxxxxxxxxxxx|
    //   minDiffB:    (7)^(8)
    let deltaType = TextTileDeltaType.Update;
    let previousChar = undefined;
    if (oldText.length !== newText.length) {
        if (oldTextDiffEnd === position) {
            deltaType = TextTileDeltaType.Add;
            previousChar = oldText[oldText.length - 1];
        }
        else if (newTextDiffEnd === position) {
            deltaType = TextTileDeltaType.Delete;
            previousChar = newText[newText.length - 1];
        }
    }
    else if (oldText === newText) {
        // If content and length are the same it is non-content delta
        return undefined;
    }
    let length = 0;
    let content;
    switch (deltaType) {
        case TextTileDeltaType.Update:
            length = oldTextDiffEnd - position;
            content = newText.substring(position, newTextDiffEnd);
            break;
        case TextTileDeltaType.Add:
            content = newText.substring(position, newTextDiffEnd);
            break;
        case TextTileDeltaType.Delete:
            length = oldTextDiffEnd - position;
            content = oldText.substring(position, oldTextDiffEnd);
            break;
    }
    const unit = determineDeltaUnit(content, previousChar);
    if (unit === undefined) {
        return undefined;
    }
    return new FormattedTextTileDelta({
        content: deltaType !== TextTileDeltaType.Delete ? content : undefined,
        deltaType,
        unit,
        position,
        length: deltaType !== TextTileDeltaType.Add ? length : 0
    });
}
function createCursorUpdateDelta(oldTile, newTile, contentDelta) {
    var _a, _b, _c, _d, _e, _f;
    const formatedTileOld = oldTile;
    const formatedTileNew = newTile;
    if ((formatedTileOld === null || formatedTileOld === void 0 ? void 0 : formatedTileOld.ipPosition) === (formatedTileNew === null || formatedTileNew === void 0 ? void 0 : formatedTileNew.ipPosition) && (formatedTileOld === null || formatedTileOld === void 0 ? void 0 : formatedTileOld.isColdIp) === (formatedTileNew === null || formatedTileNew === void 0 ? void 0 : formatedTileNew.isColdIp)) {
        return undefined;
    }
    if ((formatedTileOld === null || formatedTileOld === void 0 ? void 0 : formatedTileOld.isColdIp) === (formatedTileNew === null || formatedTileNew === void 0 ? void 0 : formatedTileNew.isColdIp) && contentDelta) {
        if (contentDelta.deltaType === TextTileDeltaType.Add) {
            // For add delta, cursor should be updated to delta.position + delta.length, if thats the case we skip CursorUpdate delta since it will be recreated this way on server
            if ((formatedTileNew === null || formatedTileNew === void 0 ? void 0 : formatedTileNew.ipPosition) === (((_a = contentDelta.position) !== null && _a !== void 0 ? _a : 0) + ((_b = contentDelta.length) !== null && _b !== void 0 ? _b : 0))) {
                return undefined;
            }
        }
        else if (contentDelta.deltaType === TextTileDeltaType.Update) {
            // For update delta, cursor should be updated to delta.position + delta.content.length, if thats the case we skip CursorUpdate delta since it will be recreated this way on server
            if ((formatedTileNew === null || formatedTileNew === void 0 ? void 0 : formatedTileNew.ipPosition) === (((_c = contentDelta.position) !== null && _c !== void 0 ? _c : 0) + ((_e = (_d = contentDelta.content) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0))) {
                return undefined;
            }
        }
        else if (contentDelta.deltaType === TextTileDeltaType.Delete) {
            // For delete delta, cursor should be updated to delta.position, if thats the case we skip CursorUpdate delta since it will be recreated this way on server
            if ((formatedTileNew === null || formatedTileNew === void 0 ? void 0 : formatedTileNew.ipPosition) === ((_f = contentDelta.position) !== null && _f !== void 0 ? _f : 0)) {
                return undefined;
            }
        }
    }
    return new FormattedTextTileDelta({
        deltaType: TextTileDeltaType.CursorUpdate,
        cursorData: {
            ipPosition: formatedTileNew === null || formatedTileNew === void 0 ? void 0 : formatedTileNew.ipPosition,
            isColdIp: formatedTileNew === null || formatedTileNew === void 0 ? void 0 : formatedTileNew.isColdIp
        }
    });
}
function createFormattingUpdateDelta(oldTile, newTile, contentDelta) {
    var _a, _b, _c, _d, _e, _f, _g;
    const formatedTileOld = oldTile;
    const formatedTileNew = newTile;
    // If there are more iems in formatedTileNew.formattedRanges just skip and return new FormattingUpdate delta
    if (((_a = formatedTileNew.formattedRanges) === null || _a === void 0 ? void 0 : _a.length) <= ((_b = formatedTileOld.formattedRanges) === null || _b === void 0 ? void 0 : _b.length)) {
        // In case there was content change we need to check for range changes and later compare it with those in updated tile
        if (contentDelta) {
            let updatedRanges = formatedTileOld.formattedRanges ? [...formatedTileOld.formattedRanges] : [];
            const range = findRangeForDeltaType(formatedTileOld.formattedRanges, contentDelta, contentDelta.position);
            // If a range has been found, identify the index of it in the list of ranges
            const index = range ? updatedRanges.indexOf(range) : -1;
            // If the delta happened within a formatted range, adjust the range length
            if (index !== -1) {
                // Operation extends beyond this formatted range
                if (contentDelta.position + (contentDelta.length || 0) > range.start + range.length) {
                    range.length = contentDelta.position + ((_c = contentDelta.content) !== null && _c !== void 0 ? _c : '').length - range.start;
                }
                else {
                    range.length += ((_d = contentDelta.content) !== null && _d !== void 0 ? _d : '').length - (contentDelta.length || 0);
                }
                updatedRanges[index] = range;
            }
            if (updatedRanges.length > 0) {
                // Shift any updated ranges that came after the updated range
                for (const updatedRange of updatedRanges.slice(index + 1)) {
                    if (updatedRange.start < contentDelta.position) {
                        continue;
                    }
                    // Operation extended into (or beyond) current range
                    if (contentDelta.position + (contentDelta.length || 0) > updatedRange.start) {
                        updatedRange.length = (updatedRange.start + updatedRange.length) - (contentDelta.position + (contentDelta.length || 0));
                        updatedRange.start = contentDelta.position + ((_e = contentDelta.content) !== null && _e !== void 0 ? _e : '').length;
                    }
                    else {
                        updatedRange.start += ((_f = contentDelta.content) !== null && _f !== void 0 ? _f : '').length - (contentDelta.length || 0);
                    }
                }
                // Remove any ranges with zero-length (or less) after a delete or update operation
                updatedRanges = updatedRanges.filter((range) => range.length > 0);
            }
            const newFormatedRanges = (_g = formatedTileNew === null || formatedTileNew === void 0 ? void 0 : formatedTileNew.formattedRanges) !== null && _g !== void 0 ? _g : [];
            // Compare updatedRanges with new formatedRanges and if there is no diff return undefined
            // since in SessionCache delta handler we will reconstruct this change - reffer to applyFormattedTextTileDelta in delta-handler.ts
            if (equal(updatedRanges, newFormatedRanges) || (updatedRanges.length === 0 && newFormatedRanges.length === 0)) {
                return undefined;
            }
        }
        else if (equal(formatedTileOld === null || formatedTileOld === void 0 ? void 0 : formatedTileOld.formattedRanges, formatedTileNew === null || formatedTileNew === void 0 ? void 0 : formatedTileNew.formattedRanges)) {
            return undefined;
        }
    }
    return new FormattedTextTileDelta({
        deltaType: TextTileDeltaType.FormattingUpdate,
        formattedRanges: formatedTileNew === null || formatedTileNew === void 0 ? void 0 : formatedTileNew.formattedRanges
    });
}
function createOtherNonContentUpdateDelta(oldTile, newTile) {
    const formatedTileOld = oldTile;
    const formatedTileNew = newTile;
    let property;
    const diff = {};
    let hasDiff = false;
    for (property in formatedTileNew) {
        if (['ipPosition', 'isColdIp', 'content', 'formattedRanges'].indexOf(property) !== -1) {
            // Already covered for content, cursor and formatted update deltas
            continue;
        }
        if (!equal(formatedTileNew[property], formatedTileOld[property])) {
            hasDiff = true;
            diff[property] = formatedTileNew[property];
        }
    }
    if (hasDiff) {
        return new FormattedTextTileDelta({
            deltaType: TextTileDeltaType.OtherNonContentUpdate,
            otherNonContentData: diff
        });
    }
    return undefined;
}
function findRangeForDeltaType(ranges, contentDelta, position) {
    // Check if there are any ranges to look through
    if (!ranges) {
        return undefined;
    }
    // Add operations generally look to the position one before them when determining what formatted
    // range to extend, the edge cases being the start of a tile (position 0) or the start of a
    // zero-length formatted range.
    // Check for these edge cases
    if (contentDelta.deltaType === TextTileDeltaType.Add) {
        const zeroLengthRangeAtPosition = ranges.find((range) => range.start === position && range.length === 0);
        if (zeroLengthRangeAtPosition) {
            return zeroLengthRangeAtPosition;
        }
        position = Math.max(position - 1, 0);
    }
    // Check for the range wherein the position is between (inclusive) the start and end of the range
    const foundRange = ranges.find((range) => {
        if (range.length === 0) {
            return range.start === position;
        }
        return range.start <= position && position < (range.start + range.length);
    });
    return foundRange;
}
function determineDeltaUnit(content, previousChar) {
    // First check word boundaries
    const wordBoundaryMatches = Array.from(content.matchAll(WORD_BOUNDARY_REGEXP));
    // Reset stateful regexp
    WORD_BOUNDARY_REGEXP.lastIndex = 0;
    // No word separators, return Chars
    if (wordBoundaryMatches.length === 0) {
        return TextTileDeltaUnit.Chars;
    }
    // One word separator, check if it's a sentence or a single word
    if (wordBoundaryMatches.length === 1) {
        // If the delta starts with the word boundary
        if (wordBoundaryMatches[0].index === 0) {
            // Delta is the word boundary following a sentence boundary
            if (previousChar && SENTENCE_BOUNDARY_REGEXP.test(previousChar)) {
                return TextTileDeltaUnit.Sentence;
                // Delta is the word boundary following a word
            }
            else if (previousChar && !WORD_BOUNDARY_REGEXP.test(previousChar)) {
                return TextTileDeltaUnit.Word;
            }
            // Potentially multiple word boundaries in a row
            return TextTileDeltaUnit.Chars;
            // If the delta ends with the word boundary
        }
        else if (wordBoundaryMatches[0].index + 1 === content.length) {
            // If the word boundary comes after a sentence boundary
            if (SENTENCE_BOUNDARY_REGEXP.test(content[wordBoundaryMatches[0].index - 1])) {
                return TextTileDeltaUnit.Sentence;
                // If the word boundary comes after a non-sentence or non-word boundary
            }
            else if (!WORD_BOUNDARY_REGEXP.test(content[wordBoundaryMatches[0].index - 1])) {
                return TextTileDeltaUnit.Word;
            }
            // Potentially multiple word boundaries in a row
            return TextTileDeltaUnit.Chars;
            // The word boundary is in the middle of the delta
        }
        else {
            // Check the content before the word boundary
            if (content[wordBoundaryMatches[0].index - 1]) {
                const previous = content[wordBoundaryMatches[0].index - 1];
                // Following a sentence boundary, return sentence
                if (SENTENCE_BOUNDARY_REGEXP.test(previous)) {
                    return TextTileDeltaUnit.Sentence;
                }
                // For multiple word boundaries in a row, return char
                if (WORD_BOUNDARY_REGEXP.test(previous)) {
                    return TextTileDeltaUnit.Chars;
                }
            }
            // With only one word boundary it can at most be a word if it is not a sentence
            return TextTileDeltaUnit.Word;
        }
    }
    // Multiple word boundaries, check for sentence boundaries
    const sentenceBoundaryMatches = Array.from(content.matchAll(SENTENCE_BOUNDARY_REGEXP));
    // Reset stateful regexp
    SENTENCE_BOUNDARY_REGEXP.lastIndex = 0;
    // No sentence boundaries, return PartialSentence
    if (sentenceBoundaryMatches.length === 0) {
        return TextTileDeltaUnit.PartialSentence;
    }
    // Multiple sentence boundaries, return Paragraph
    if (sentenceBoundaryMatches.length > 1) {
        return TextTileDeltaUnit.Paragraph;
    }
    // Only one sentence boundary, check the position
    if (sentenceBoundaryMatches[0].index + 1 <= content.length) {
        // Note: Only send "Sentence" if it has a word separator after it
        if (WORD_BOUNDARY_REGEXP.test(content[sentenceBoundaryMatches[0].index + 1])) {
            return TextTileDeltaUnit.Sentence;
        }
        // Otherwise, should be Paragraph (multiple-sentences)
        return TextTileDeltaUnit.Paragraph;
    }
    return undefined;
}
//# sourceMappingURL=delta-builder-handlers.js.map